import { initializeApp, deleteApp } from 'firebase/app'
import { isSupported, getMessaging, getToken, onMessage } from 'firebase/messaging'

import ALLOWED_DOMAINS from 'constants/allowed-domains'
import { displayNotification } from 'components/Notifications/NotificationMessage'
import { operator as operatorApi } from 'api'

import { FIREBASE_CONFIG, FIREBASE_VAPID_KEY } from './configuration'

class NotificationsService {
  constructor() {
    this._hasConfig = !!FIREBASE_CONFIG
    this._isSupported = false
    this._isInitialize = false
    this.app = null
    this.messaging = null
  }

  /**
   * Init notification APP
   */
  async initializeApp() {
    if (ALLOWED_DOMAINS.isLocal) return

    await this.isSupported()

    if (this._isSupported) {
      if (!this.app) this.app = initializeApp(FIREBASE_CONFIG)
      if (!this.messaging) this.messaging = getMessaging(this.app)
    }
  }

  async isSupported() {
    this._isSupported = this._hasConfig
      ? await isSupported()
      : false
  }

  initialize() {
    if (this._isInitialize) return

    if (this._isSupported && this.app) {
      onMessage(this.messaging, (payload) => {
        const { data: { msgType, title, body, key, hub, channelToken } } = payload

        displayNotification({
          title,
          message: body,
          type: msgType,
          channel: { key, hub, channelToken }
        })
      })
    }

    this._isInitialize = true
  }

  remove() {
    if (this.app) deleteApp(this.app)
    if (this.messaging) onMessage(this.messaging, () => {})
    if (this._isInitialize) this._isInitialize = false
  }

  /**
   * @see https://firebase.google.com/docs/reference/js/firebase.messaging.Messaging#requestpermission
   * @param {string} oldToken
   *
   * @returns {string}
   */
  async checkPermission(oldToken) {
    await this.initializeApp()

    if (this.app) {
      try {
        const permission = await Notification.requestPermission()

        if (permission !== 'denied') {
          const token = await getToken(this.messaging, { vapidKey: FIREBASE_VAPID_KEY })

          if (token && oldToken !== token) {
            await operatorApi.operators.updateTokenFirebase(token)
          }

          this.initialize()

          return token
        }
      } catch (error) {
        console.error(error)
      }
    }

    this.remove()
    return null
  }
}

export default new NotificationsService()